/** Auth0's browser transaction stays on the origin where sign-in started. */
export function callbackUrl(configuredUrl: string | undefined, origin: string) {
  if (!configuredUrl) return undefined;
  const configured = new URL(configuredUrl);
  const callback = new URL(origin);
  callback.pathname = configured.pathname;
  callback.search = configured.search;
  return callback.toString();
}
